import { HomePageBaseCustomElement } from 'General/Resources/Parts/HomePage/HomePageBase';
import { autoinject, customElement } from 'aurelia-framework';

@autoinject
@customElement('home-page')
export class HomePageCustomElement extends HomePageBaseCustomElement {

}